// What "Refresh DB" in the SMS Status modal changed. The backend returns each
// number whose sms_number_health row was added, removed or updated, with its
// values before and after (refresh_number_health_endpoint in
// backend/twilio_service/views_twilio_config.py). This turns one of those into
// "Good -> Bad, +1 failed" using the same status rules as the badges.

import { numberStatusFromRows } from "./numberStatus";

// Most urgent first: a number that just went bad is what the user is after.
const STATUS_ORDER = ["bad", "failing", "opt_out", "unknown", "good", "untexted"];

const count = (n, word) => `${n > 0 ? "+" : ""}${n} ${word}`;

/** { from, to, statusChanged, notes } for one change from the backend. */
export const describeChange = (change) => {
  const before = change.before;
  const after = change.after;
  const from = before ? numberStatusFromRows([before]) : "untexted";
  const to = after ? numberStatusFromRows([after]) : "untexted";
  const notes = [];
  if (!before) notes.push("first texts found");
  if (!after) notes.push("no texts left to this number");
  if (before && after) {
    const delivered = (after.delivered_count || 0) - (before.delivered_count || 0);
    const failed = (after.failed_count || 0) - (before.failed_count || 0);
    if (delivered) notes.push(count(delivered, "delivered"));
    if (failed) notes.push(count(failed, "failed"));
    if (after.last_error_code && after.last_error_code !== before.last_error_code) {
      notes.push(`error ${after.last_error_code}${after.error_description ? ` (${after.error_description})` : ""}`);
    }
    if (after.on_do_not_text !== before.on_do_not_text) {
      notes.push(after.on_do_not_text ? "added to Do Not Text" : "removed from Do Not Text");
    }
    if (!notes.length) notes.push("new activity");
  }
  return { from, to, statusChanged: from !== to, notes };
};

/** Changes with their description, status changes first, most urgent first. */
export const sortChanges = (changes) =>
  (changes || [])
    .map((c) => ({ ...c, ...describeChange(c) }))
    .sort(
      (a, b) =>
        Number(b.statusChanged) - Number(a.statusChanged) ||
        STATUS_ORDER.indexOf(a.to) - STATUS_ORDER.indexOf(b.to) ||
        a.phone_number.localeCompare(b.phone_number),
    );
